import { createFeatureSelector, createSelector } from '@ngrx/store';

import { productBoxFeatureKey, ProductBoxState } from 'app/state/product-boxes/product-box.reducer';

export const selectProductBoxState = createFeatureSelector<ProductBoxState>(productBoxFeatureKey);

export const selectProductBoxList = createSelector(selectProductBoxState, (state) => state.productBoxList);

export const selectProductBoxByNumber = (productBoxNumber: number) =>
    createSelector(selectProductBoxList, (productBoxList) =>
        productBoxList.find((c) => c.number === productBoxNumber),
    );

export const selectProductBoxListBuNumbers = (productBoxNumberList: number[]) =>
    createSelector(selectProductBoxList, (productBoxList) =>
        productBoxNumberList.map((productBoxNumber) =>
            productBoxList.find((p) => p.number === productBoxNumber),
        ),
    );
